export function repeatedNeoNames(rows = []) {
  const groups = new Map();
  for (const row of rows) {
    const name = String(row.siteName || row.siteId || "").normalize("NFKC").trim().replace(/\s+/g, " ");
    const key = name.toLowerCase();
    if (!key) continue;
    if (!groups.has(key)) groups.set(key, { name, rows: [] });
    const group = groups.get(key);
    if (!group.rows.some((item) => item.siteId === row.siteId)) group.rows.push(row);
  }
  return [...groups.values()].filter((group) => group.rows.length > 1);
}
